export function InlinePageStyles() {
  return (
    <style>
      {`
      :root{
        --brand-dark: #0b1f14;
        --brand-mid: #153a26;
        --brand-accent: #57c785;
        --brand-warn: #f7c948;
      }

      .text-brand-accent {
        color: var(--brand-accent);
      }

      body { background: #ffffff; }
      .navbar-brand span { color: var(--brand-accent); }

      .hero-carousel .carousel-item {
        height: clamp(420px, 65vh, 760px);
        background: #000;
      }
      .hero-carousel .hero-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        filter: saturate(1.05);
      }
      .hero-carousel .overlay-scrim {
        position: absolute;
        inset: 0;
        background: linear-gradient(
          to top,
          rgba(0,0,0,0.65) 0%,
          rgba(0,0,0,0.35) 40%,
          rgba(0,0,0,0.15) 70%,
          rgba(0,0,0,0.05) 100%
        );
      }
      .hero-carousel .hero-content {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 2.25rem 1rem 3rem;
      }
      .hero-carousel .hero-content .container {
        max-width: 1100px;
      }
      .hero-carousel .hero-kicker {
        letter-spacing: .08em;
        text-transform: uppercase;
        font-weight: 700;
        font-size: .85rem;
        color: rgba(255,255,255,0.85);
      }
      .hero-carousel h1,
      .hero-carousel h2,
      .hero-carousel p { color: #fff; }
      .hero-carousel h1 {
        font-weight: 800;
        font-size: clamp(1.7rem, 3.4vw, 3rem);
        line-height: 1.1;
        margin: .35rem 0 .75rem;
        text-shadow: 0 8px 28px rgba(0,0,0,0.55);
      }
      .hero-carousel p {
        max-width: 56rem;
        font-size: clamp(1rem, 1.35vw, 1.125rem);
        color: rgba(255,255,255,0.92);
        text-shadow: 0 6px 20px rgba(0,0,0,0.45);
        margin-bottom: 1.25rem;
      }
      .hero-carousel .btn-primary {
        background: var(--brand-accent);
        border-color: var(--brand-accent);
        color: #0b1f14;
        font-weight: 700;
      }
      .hero-carousel .btn-outline-light {
        border-width: 2px;
        font-weight: 700;
      }
      .trust-badges {
        color: rgba(255,255,255,0.9);
        font-size: .95rem;
        display: flex;
        flex-wrap: wrap;
        gap: .75rem 1.1rem;
        align-items: center;
        margin-top: 1rem;
      }
      .trust-badges .dot {
        width: 7px; height: 7px; border-radius: 50%;
        background: var(--brand-accent);
        display: inline-block;
        margin-right: .45rem;
      }

      .section-title { font-weight: 800; }
      .feature-card {
        border: 1px solid rgba(0,0,0,0.08);
        border-radius: 1rem;
        box-shadow: 0 8px 20px rgba(0,0,0,0.04);
      }
      .icon-badge{
        width: 44px; height: 44px;
        border-radius: 12px;
        background: rgba(87,199,133,0.15);
        display: grid;
        place-items: center;
        font-weight: 900;
        color: var(--brand-mid);
      }

      .cta-band{
        background: linear-gradient(135deg, var(--brand-dark), var(--brand-mid));
        color: #fff;
        border-radius: 1.25rem;
      }

      .fineprint { color: rgba(0,0,0,0.65); font-size: .95rem; }
      footer { color: rgba(255,255,255,0.75); background: #0b1f14; }
      footer a { color: rgba(255,255,255,0.9); }

      section { scroll-margin-top: 90px; }
    `}
    </style>
  );
}

